<template>
  <div id="users-list">
    <table class="table" v-if="$store.state.responsive.viewDesktopLists">
      <thead class="fixheader">
        <tr>
          <th scope="col" style="min-width: 12ch !important; word-break: break-all;">
            <ThOrder :textHeader="'Nombre de Usuario'" :idHeader="'name'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th scope="col">
            <ThOrder :textHeader="'Vendor'" :idHeader="'vendor'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th scope="col" style="min-width: 12ch !important; word-break: break-all;">
            <ThOrder :textHeader="'Email'" :idHeader="'email'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th scope="col">
            <ThOrder :textHeader="'Tenant'" :idHeader="'tenant'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th scope="col">
            <ThOrder :textHeader="'Store'" :idHeader="'store'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th scope="col">
            <ThOrder :textHeader="'Roles'" :idHeader="'rol'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th scope="col" class="align-middle thOperaciones"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(user, index) in usersAux" v-bind:key="index">
          <td class="align-middle py-4" style="min-width: 12ch !important; word-break: break-all;">{{ user.username }}</td>
          <td class="align-middle py-4">{{ user.vendor }}</td>
          <td class="align-middle py-4" style="min-width: 12ch !important; word-break: break-all;">{{ user.email }}</td>
          <td class="align-middle py-4">{{ user.tenant }}</td>
          <td class="align-middle py-4">{{ user.store }}</td>
          <td class="align-middle py-4"><h6 v-for="(rol, index) in user.roles" v-bind:key="index">{{ rol }}</h6></td>
          <td id="operaciones" class="align-middle py-4 tdOperaciones">
            <div class="dropdown dropdown-inherit">
              <span id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <v-icon name="fa-ellipsis-v" />
              </span>
              <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                <a class="dropdown-item py-3 px-4" href="#" data-toggle="modal" data-target="#deleteUser"
                  @click="eliminarUser(user.username)">Eliminar Usuario</a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <template v-if="!$store.state.responsive.viewDesktopLists">
      <div class="card p-2 mb-3" v-for="(user, index) in usersAux" v-bind:key="index">  
        <div class="list-item">
          <div class="item d-flex align-items-center justify-content-between px-2 py-3" data-toggle="collapse"
            :href="'#collapseExample' + index" role="button" aria-expanded="true"
            :aria-controls="'collapseExample' + index">
            <h4 class="m-0">{{ user.username }}</h4>
            <v-icon name="bi-chevron-up" />
          </div>
          <div class="collapse show ml-3 mr-2 borderFirstItem" :id="'collapseExample' + index">
            <div class="d-flex align-items-center justify-content-between flex-wrap mb-2 mt-2">
              <div class="d-flex align-items-center justify-content-start">
                <p class="m-0 mr-2"><strong>Vendor: </strong>{{ user.vendor }}</p>
              </div>
              <div>
                <div class="dropdown dropdown-inherit">
                  <span id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <v-icon name="fa-ellipsis-v" />
                  </span>
                  <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                    <a class="dropdown-item py-3 px-4" href="#" data-toggle="modal" data-target="#deleteUser"
                      @click="eliminarUser(user.username)">Eliminar Usuario</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Email: </strong>{{ user.email }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Tenant: </strong>{{ user.tenant }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Store: </strong>{{ user.store }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <div style="display: flex; flex-direction: column;">
                <p class="m-0 mr-2"><strong>Roles: </strong></p>
                <span style="margin-left: 10px;" v-for="(rol, index) in user.roles" v-bind:key="index">{{ rol }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <UserDelete :id="'deleteUser'" :modalTitle="'ELIMINAR USUARIO'" :userNameCheck="userNameCheck"
      :showFooter="false" @refreshRegisterList="refreshRegisterList($event)"></UserDelete>
  </div>
</template>

<script>
import ThOrder from '../../Shared/ThOrder.vue';
import UserDelete from './UserDelete.vue';
export default {
  name: 'UsersList',
  props: [
    'users',
  ],
  data() {
    return {
      currentOrder: '',
      currentOrderBy: '',
      usersAux: this.users,
      userNameCheck: '',
    };
  },
  updated() {
    this.usersAux = this.users
  },
  components: {
    ThOrder,
    UserDelete
  },
  methods: {
    selectOrder(value) {
      this.usersAux = this.usersAux.sort(function (a, b) {
        let valorA = a[value.orderBy] == null || a[value.orderBy] == undefined ? 0 : a[value.orderBy]
        let valorB = b[value.orderBy] == null || b[value.orderBy] == undefined ? 0 : b[value.orderBy]
        if (valorA < valorB) return -1
        if (valorA > valorB) return 1
      })
      if (value.order == 'DESC') this.usersAux = this.usersAux.reverse()
    },
    refreshRegisterList() {
      this.$emit("sendRefreshRegisterList");
    },
    eliminarUser: function (info) {
      console.log(info)
      this.userNameCheck = info
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#operaciones {
  text-align: right;
}

thead {
  background-color: rgb(250, 250, 250);
}

.col-12 {
  padding: 0%;
}
</style>
